import { render, staticRenderFns } from "./RoleMenuAuth.vue?vue&type=template&id=b9092568&scoped=true&"
import script from "./RoleMenuAuth.vue?vue&type=script&lang=js&"
export * from "./RoleMenuAuth.vue?vue&type=script&lang=js&"
import style0 from "./RoleMenuAuth.vue?vue&type=style&index=0&id=b9092568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9092568",
  null
  
)

export default component.exports